var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{class:_vm.itemCls},[_c('div',{class:_vm.timeSC.classes,style:(_vm.timeSC.styles)},[_vm._t("time")],2),_c('div',{class:_vm.prefix + '-item-content'},[_c('div',{class:_vm.circleSC.classes,style:(_vm.circleSC.styles)},[_c('i',{class:_vm.icon})]),_vm._t("content"),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }